import dynamic from "next/dynamic";

export const LazyInputPhone = dynamic(() => import("./ReactPhoneNumberInput"));
